export default __webpack_public_path__ + "static/media/fullscreen.24af8d96.svg";